<template>
  <div>
    <input
      class="input"
      v-if="$store.getters.languageQuestionAdmin === 'fr'"
      @focus="
        dragDisabled = true;
        parentDragOff();
      "
      :placeholder="$t('question.placeholder_proposition')"
      v-model="answer.entitled"
      @input="functionTestSaveQuestionButton"
      v-on:keyup="functionTestSaveQuestionButton"
      size="is-small"
      expanded
      required
      maxlength="255"
      :has-counter="false"
    />
    <input
      class="input"
      v-if="$store.getters.languageQuestionAdmin === 'en'"
      @focus="
        dragDisabled = true;
        parentDragOff();
      "
      :placeholder="$t('question.placeholder_proposition')"
      v-model="answer.entitled_en"
      @input="functionTestSaveQuestionButton"
      v-on:keyup="functionTestSaveQuestionButton"
      size="is-small"
      expanded
      required
      maxlength="255"
      :has-counter="false"
    />
    <input
      class="input"
      v-if="$store.getters.languageQuestionAdmin === 'es'"
      @focus="
        dragDisabled = true;
        parentDragOff();
      "
      :placeholder="$t('question.placeholder_proposition')"
      v-model="answer.entitled_es"
      @input="functionTestSaveQuestionButton"
      v-on:keyup="functionTestSaveQuestionButton"
      size="is-small"
      expanded
      required
      maxlength="255"
      :has-counter="false"
    />
    <input
      class="input"
      v-if="$store.getters.languageQuestionAdmin === 'de'"
      @focus="
        dragDisabled = true;
        parentDragOff();
      "
      :placeholder="$t('question.placeholder_proposition')"
      v-model="answer.entitled_de"
      @input="functionTestSaveQuestionButton"
      v-on:keyup="functionTestSaveQuestionButton"
      size="is-small"
      expanded
      required
      maxlength="255"
      :has-counter="false"
    />
  </div>
</template>

<script>
export default {
  name: 'InputAnswersTranslation',
  props: ['dragDisabled', 'answer'],
  methods: {
    functionTestSaveQuestionButton () {
      this.$store.commit('TEST_SAVE_QUESTION_BUTTON')
    },
    parentDragOff () {
      this.$emit('dragDisabled', true)
    }
  }
}
</script>
<style scoped>
.input {
  background: #eeeeee !important;
  border-radius: 0px;
  box-shadow: none;
  font-size: 12px;
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/question/components/InputAnswersTranslation.vue